<div class="chat-unavailable-container">
    <div>Chat support is currently closed.</div>
    <div class="chat-unavailable-support-hours-sub-heading">Support Hours</div>
    <div class="chat-unavailable-hours-of-operation-container">
        <div class="chat-unavailable-hours margin-bottom">
            <div>Pharmacy:</div>
            <div>
                <div>8:00 AM to 5:00 PM EST</div>
                <div>Monday to Friday</div>
            </div>
            <div class="chat-unavailable-closed-label italicized-font">closed</div>
            <div class="italicized-font">12:00 PM to 1:00 PM EST daily</div>
        </div>

        <div class="chat-unavailable-hours margin-bottom">
            <div>Provider Services:</div>
            <div>
                <div>8:00 AM to 5:00 PM EST</div>
                <div>Monday to Friday</div>
            </div>
            <div class="chat-unavailable-closed-label italicized-font">closed</div>
            <div class="italicized-font">12:00 PM to 1:00 PM EST daily</div>
        </div>

        <div class="chat-unavailable-hours">
            <div>Clinical Operations:</div>
            <div>
                <div>8:00 AM to 4:30 PM EST</div>
                <div>Monday to Friday</div>
            </div>
            <div class="chat-unavailable-closed-label italicized-font">closed</div>
            <div class="italicized-font">12:00 PM to 1:00 PM EST daily</div>
        </div>
    </div>
</div>
